// components
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';
import Label from '../../../components/Label';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  home: getIcon('ic_home'),
  group: getIcon('ic_group'),
  user: getIcon('ic_user'),
  school: getIcon('ic_school'),
  accounting: getIcon('ic_accounting'),
  receipt: getIcon('ic_receipt'),
  book: getIcon('ic_book'),
  setting: getIcon('ic_setting'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
};

const roles = {
  admissions: ['admin', 'admission'],
  colleges: ['admin'],
  accounting: ['admin', 'accounting'],
  cashiering: ['admin', 'accounting', 'cashiering'],
  registrar: ['admin', 'registrar'],
  administrator: ['admin'],
  faculty: ['admin', 'faculty'],
}

export const adminNavConfig = [
  {
    subheader: 'Docs',
    items: [
      {
        title: 'menu_level_1',
        path: '#/dashboard/menu_level_1',
        icon: ICONS.menuItem,
        children: [
          { title: 'menu_level_2a', path: '/admin/docs/menu_level_1/menu_level_2a' },
          {
            title: 'menu_level_2b',
            path: '#/dashboard/menu_level_1/menu_level_2b',
            children: [
              {
                title: 'menu_level_3a',
                path: '/admin/docs/menu_level_1/menu_level_2b/menu_level_3a',
              },
              {
                title: 'menu_level_3b',
                path: '/admin/docs/menu_level_1/menu_level_2b/menu_level_3b',
                children: [
                  {
                    title: 'menu_level_4a',
                    path: '/admin/docs/menu_level_1/menu_level_2b/menu_level_3b/menu_level_4a',
                  },
                  {
                    title: 'menu_level_4b',
                    path: '/admin/docs/menu_level_1/menu_level_2b/menu_level_3b/menu_level_4b',
                  },
                ],
              },
            ],
          },
        ],
      },
      { title: 'item_disabled', path: '#disabled', icon: ICONS.menuItem, disabled: true },
      {
        title: 'item_label',
        path: '#label',
        icon: ICONS.menuItem,
        info: (
          <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
            NEW
          </Label>
        ),
      },
      {
        title: 'item_caption',
        path: '#caption',
        icon: ICONS.menuItem,
        caption:
          'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
      },
      { title: 'item_external_link', path: 'https://www.google.com/', icon: ICONS.menuItem },
    ],
  },
];


export const studentNavConfig = [
  {
    subheader: 'Student Docs',
    items: [
      {
        title: 'menu_level_1',
        path: '#/dashboard/menu_level_1',
        icon: ICONS.menuItem,
        children: [
          { title: 'menu_level_2a', path: '/student/docs/menu_level_1/menu_level_2a' },
          {
            title: 'menu_level_2b',
            path: '#/dashboard/menu_level_1/menu_level_2b',
            children: [
              {
                title: 'menu_level_3a',
                path: '/student/docs/menu_level_1/menu_level_2b/menu_level_3a',
              },
              {
                title: 'menu_level_3b',
                path: '/student/docs/menu_level_1/menu_level_2b/menu_level_3b',
                children: [
                  {
                    title: 'menu_level_4a',
                    path: '/student/docs/menu_level_1/menu_level_2b/menu_level_3b/menu_level_4a',
                  },
                  {
                    title: 'menu_level_4b',
                    path: '/student/docs/menu_level_1/menu_level_2b/menu_level_3b/menu_level_4b',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: 'item_label',
        path: '#label',
        icon: ICONS.menuItem,
        info: (
          <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
            NEW
          </Label>
        ),
      },
    ],
  },
];

export const applyNavConfig = [
  {
    subheader: 'Applicant Docs',
    items: [
      {
        title: 'menu_level_1',
        path: '#/dashboard/menu_level_1',
        icon: ICONS.menuItem,
        children: [
          { title: 'menu_level_2a', path: '/apply/docs/menu_level_1/menu_level_2a' },
          {
            title: 'menu_level_2b',
            path: '#/dashboard/menu_level_1/menu_level_2b',
            children: [
              {
                title: 'menu_level_3a',
                path: '/apply/docs/menu_level_1/menu_level_2b/menu_level_3a',
              },
              {
                title: 'menu_level_3b',
                path: '/apply/docs/menu_level_1/menu_level_2b/menu_level_3b',
                children: [
                  {
                    title: 'menu_level_4a',
                    path: '/apply/docs/menu_level_1/menu_level_2b/menu_level_3b/menu_level_4a',
                  },
                  {
                    title: 'menu_level_4b',
                    path: '/apply/docs/menu_level_1/menu_level_2b/menu_level_3b/menu_level_4b',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: 'item_label',
        path: '#label',
        icon: ICONS.menuItem,
        info: (
          <Label color="info" startIcon={<Iconify icon="eva:email-fill" />}>
            NEW
          </Label>
        ),
      },
    ],
  }
]